var map = {
	"./banner.jpg": "abde",
	"./gift_1.jpg": "bc27",
	"./gift_2.jpg": "3da7",
	"./login_page_bac0.jpg": "98a1",
	"./q22.jpg": "aeb2",
	"./q23.jpg": "0dcb",
	"./q27.jpg": "31b7",
	"./q28.jpg": "ae59"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9853";